(function(){function debounce(delay=500,callback){let timer;return function(){clearTimeout(timer),timer=null,timer=setTimeout(()=>{callback()},delay)}}const initRes=init();if(typeof initRes=="string"){console.log("Init info: ",initRes);return}else importStyles(),console.log("App is on!");const{debug,shopId,baseUrl,MAX_SEARCH_TIMES}=initRes;let{times}=initRes;const btnAndPopupData=initBtnAndPopupData(),{buttonStyleUrl,popupStyleUrl,integrationUrl,floatBtnPosition,buttonData,generalData,formAction}=btnAndPopupData;let{iti,popupData,inlineBtnHeight,inlineBtnWidth,btnRadius,btnFontSize,btnFontWeight,insertEl,insertType,selectedType,selBtnStatus,btnStyleSwitch,popupStyleSwitch,inteStatus}=btnAndPopupData;const elements=initElement();let{inlineBtnElement,floatBtnElement,emailFrameElement,inlineEmailDiv,floatEmailDiv,invalidTip,successFrame,variantSelector,closeBox,submitBtn,emailInput,nameInput,smsInput,mailingCheckbox,soldOutBtn,exactForm}=elements;const{trueForms}=elements,productInfo=initProductInfo();let{currentVariant,available,selectVariantId,productTitle,currentVariantOption,addOptionsStatus,initUrl,listenVariantFlag}=productInfo;const{variantData,unVariantOptions}=productInfo,payment_button_class=".shopify-payment-button";debug&&console.log("Init data finished"),searchParentEl().then(res=>{debug&&console.log("SearchParentEl finished");const{code}=res;if(code===501){console.log("Search Node Failed"),handleSearchNodeFailed().then(searchRes=>{searchRes.code===200&&(handleBasicData(),getAllStyle())});return}code===200&&(debug&&console.log("SearchParentEl success"),handleBasicData(),getAllStyle())});function init(){const ENV="prod",baseUrl2=ENV.indexOf("dev")===-1?"https://emailnoticeapi.sealapps.com/":"https://emailnoticeapitest.sealapps.com/",debug2=ENV.indexOf("dev")!==-1,{ShopifyAnalytics}=window;if(ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.page&&ShopifyAnalytics.meta.page.pageType!=="product")return"Not in product page";if(location.href.indexOf("product")===-1)return"Not in product page";const shopId2=JSON.parse(qa("#shopify-features")[0].outerText).shopId;changeStatus({shopId:shopId2,baseUrl:baseUrl2});const shopMeta=JSON.parse(q("#em_product_metafields").textContent);return shopMeta?JSON.parse(q("#em_product_variants").textContent).some(v=>v.available===!1)?q("#product-restore-email-flag")||q("#product-restore-email-float")||q("#product-restore-email")?"Already enabled":(document.body.insertAdjacentHTML("beforeend",`
      <div id="product-restore-email-flag" style="display: none;"></div>
      `),{debug:debug2,shopMeta,shopId:shopId2,baseUrl:baseUrl2,MAX_SEARCH_TIMES:50,times:0}):"All variants are in stock.":"no shopMeta"}function initProductInfo(){const variantData2=JSON.parse(q("#em_product_variants").textContent),hasAvailableV=variantData2.some(v=>v.available===!1),currentVariant2=JSON.parse(q("#em_product_selected_or_first_available_variant").textContent);return{variantData:variantData2,currentVariant:currentVariant2,available:currentVariant2.available,selectVariantId:currentVariant2.id,hasAvailableV,productTitle:"",unVariantOptions:[],currentVariantOption:null,addOptionsStatus:0,initUrl:document.URL,listenVariantFlag:!0}}function initBtnAndPopupData(){return{btnRadius:"",btnFontSize:"",inlineBtnWidth:"",inlineBtnHeight:"",btnFontWeight:"initial",popupStyleUrl:"getPopupStyle",buttonStyleUrl:"getButtonStyle",integrationUrl:"integrate/getIntegration",floatBtnPosition:"float-btn-right",buttonData:{btn_value:"",btn_color:"",font_color:"",btn_margin_top:"",inline_status:0,float_btn_value:"",float_btn_color:"",float_font_color:"",btn_insert_customized:0,btn_insert_el:"",btn_insert_type:"",offset:0,float_status:0,is_branding_removed:0},generalData:{btn_display_all:0,btn_font_family:"inherit",btn_font_size:"14",btn_font_weight:"inherit",btn_hover_animation:0,btn_hover_color:"#333333",btn_hover_font_color:"#ffffff",btn_margin_top:"0",btn_border_radius:"0",btn_border_color:"transparent"},popupData:null,frameBtnColor:"#333333",frameBtnFontColor:"#ffffff",insertType:"",insertEl:null,selectedType:{},iti:null,selBtnStatus:0,btnStyleSwitch:0,popupStyleSwitch:0,inteStatus:0,formAction:"https://"+document.domain+"/cart/add"}}function initElement(){return{inlineBtnElement:null,floatBtnElement:null,emailFrameElement:null,inlineEmailDiv:null,floatEmailDiv:null,invalidTip:null,successFrame:null,variantSelector:null,closeBox:null,submitBtn:null,soldOutBtn:null,emailInput:null,nameInput:null,smsInput:null,mailingCheckbox:null,trueForms:[],exactForm:null}}function getBtnStyle(btn){if(btn.tagName=="DIV"&&(btn=btn.querySelector("button")),!btn)return;const btnStyle=window.getComputedStyle(btn,null);btnStyle.width=="auto"||!btnStyle.width?inlineBtnWidth="":btnStyle.width.indexOf("px")!==-1&&parseFloat(btnStyle.width)>120&&(inlineBtnWidth=btnStyle.width),btnStyle.height=="auto"||!btnStyle.height?inlineBtnHeight="":inlineBtnHeight=btnStyle.height,btnRadius=btnStyle.borderRadius,btnFontSize=btnStyle.fontSize,btnFontWeight=btnStyle.fontWeight}function getSoldOutBtn(trueForm){const btnArr=trueForm.querySelectorAll("button"),iptArr=[...trueForm.querySelectorAll("input[type='submit']"),...trueForm.querySelectorAll("input[type='button']")],allArr=[...btnArr,...iptArr];if(allArr.length){for(let i=0;i<allArr.length;i++)if(allArr[i].type=="submit"&&allArr[i].name=="add"||allArr[i].type=="submit"&&allArr[i].name=="button"){soldOutBtn=allArr[i];break}if(!soldOutBtn){for(let i=0;i<allArr.length;i++)if(allArr[i].type=="submit"){soldOutBtn=allArr[i];break}}if(!soldOutBtn){for(let i=0;i<allArr.length;i++)if(allArr[i].disabled){soldOutBtn=allArr[i];break}}soldOutBtn||(soldOutBtn=allArr[0]),soldOutBtn&&getBtnStyle(soldOutBtn)}}function searchParentEl(){return new Promise(resolve=>{const forms=qa("form");for(let i=0;i<forms.length;i++)forms[i].action.indexOf("/cart/add")!==-1&&trueForms.push(forms[i]);if(trueForms.length||resolve({code:501,msg:"Search el failed"}),trueForms.length==1)exactForm=trueForms[0],getSoldOutBtn(trueForms[0]);else for(let i=0;i<trueForms.length&&!soldOutBtn;i++){const formStyle=window.getComputedStyle(trueForms[i],null);if(!(formStyle.visibility!="visible"||formStyle.display=="none"||formStyle.height=="0px"||formStyle.height=="0"||formStyle.width=="0px"||formStyle.width=="0"||formStyle.height=="auto")){if(exactForm=trueForms[i],getSoldOutBtn(trueForms[i]),soldOutBtn){const parent=soldOutBtn.parentElement,parentStyle=window.getComputedStyle(parent,null);if(parentStyle.visibility=="visible"&&parentStyle.display!="none"&&parentStyle.height!=0&&parentStyle.width!=0)break}if(soldOutBtn=trueForms[i].querySelector(payment_button_class),soldOutBtn)break;{const iptSubArr=trueForms[i].querySelectorAll("input[type='submit']");if(iptSubArr.length!=0){soldOutBtn=iptSubArr[0];break}const btnArr=trueForms[i].querySelectorAll("button");for(let j=0;j<btnArr.length;j++)if(btnArr[j].type=="submit"){soldOutBtn=btnArr[j];break}}}}if(soldOutBtn||exactForm){const params={code:200,msg:"success"};soldOutBtn?(insertType="afterend",insertEl=soldOutBtn):(insertType="beforeend",insertEl=exactForm),resolve(params)}else times>=MAX_SEARCH_TIMES?resolve({code:501,msg:"Search el failed"}):(times++,setTimeout(()=>{searchParentEl().then(res=>resolve(res))},50))})}function getParentWithoutForm(){const btnElements=qa(".action-button, [class*=add-to-cart], [class*=add_to_cart], [id*=add_to_card], [id*=add-to-card], [data-add-to-cart], .sold-out, #out-of-stock-gl");if(btnElements.length)for(let i=0;i<btnElements.length;i++){const width=Number(window.getComputedStyle(btnElements[i],null).width.split("px")[0]);if(!isNaN(width)&&width>64)return{type:"afterend",ele:btnElements[i]}}const parents=qa(".action-button, .tt-swatches-container.tt-swatches-container-js");if(parents.length)for(let i=0;i<parents.length;i++){const style=window.getComputedStyle(parents[i],null);if(!(style.visibility!="visible"||style.display=="none"||style.height=="0px"||style.height=="0"||style.width=="0px"||style.width=="0"||style.height=="auto"))return{type:"beforeend",ele:parents[i]}}return{type:""}}function setInlineBtnWhenErr(el){const res=getParentWithoutForm();res.type&&res.ele.insertAdjacentHTML(res.type,el),getBISEle()}function handleSearchNodeFailed(){return new Promise(resolve=>{getButtonStyle(shopId,buttonStyleUrl).then(()=>{buttonData.btn_insert_el?resolve({code:200}):getParentWithoutForm().type?resolve({code:200}):resolve({code:404})})})}function changeButtonPos(){debug&&console.log("changeButtonPos");const{btn_insert_customized,btn_insert_el,btn_insert_type}=buttonData;btn_insert_customized&&(insertEl=q(btn_insert_el)||soldOutBtn,insertType=btn_insert_type||"afterend")}function handleBasicData(){if(debug&&console.log("Handle Basic Data"),soldOutBtn){const parentStyle=window.getComputedStyle(soldOutBtn.parentElement,null);parentStyle.display=="flex"&&parentStyle.flexDirection=="row"&&parentStyle.flexWrap=="nowrap"&&(soldOutBtn.parentElement.style.flexWrap="wrap")}const v1=variantData[0];try{productTitle=v1.name.split(" - ")[0].trim()}catch{v1.public_title&&v1.public_title.length-3>0?productTitle=v1.name.substr(0,v1.name.length-v1.public_title.length-3):productTitle=v1.name}}function getAllStyle(){debug&&console.log("Get All Style");const btnPromise=getButtonStyle(shopId,buttonStyleUrl),popupPromise=getPopupStyle(shopId,popupStyleUrl),intePromise=getIntegration(shopId,integrationUrl);Promise.all([btnPromise,popupPromise,intePromise]).then(()=>{renderBtnAndPopup()})}function getButtonStyle(shopId2,btnurl){if(btnStyleSwitch)return new Promise(resolve=>{resolve({code:200})});debug&&console.log("Get Button Style");const url=baseUrl+"api/v1/"+btnurl;return request(url,{shopId:shopId2}).then(res=>{debug&&console.log("Get Button Style Success");const{code,data}=res;code===200&&data&&(btnStyleSwitch=1,Object.keys(buttonData).forEach(key=>{buttonData[key]=data[key]}),Object.keys(generalData).forEach(key=>{generalData[key]=data[key]}),renderSettingStyles(),changeButtonPos())})}function getPopupStyle(shopId2,popupUrl){debug&&console.log("Get Popup Style");const url=baseUrl+"api/v1/"+popupUrl;return request(url,{shopId:shopId2}).then(res=>{debug&&console.log("Get Popup Style Success");const{code,data}=res;if(code===200&&data)switch(popupStyleSwitch=1,popupData=JSON.parse(JSON.stringify(data)),popupData.popup_option){case 1:selectedType.type="email";break;case 2:selectedType.type="sms";break;case 3:selectedType.type="email";break}})}function getIntegration(shopId2,inteUrl){debug&&console.log("Get Integration");const url=baseUrl+"api/v1/"+inteUrl;return request(url,{shopId:shopId2}).then(res=>{debug&&console.log("Get Integration Success");const{code,data}=res;code===200&&data&&(debug&&console.log("inte",data),inteStatus=data.find(o=>o.is_enable))})}function renderSettingStyles(){debug&&console.log("renderSettingStyles");const{btn_font_size,btn_hover_animation,btn_border_radius,btn_border_color,btn_font_weight,btn_font_family,btn_margin_top,btn_hover_font_color,btn_hover_color}=generalData;let generalStyles=`
      .email-me-button {
        font-size: ${btn_font_size}px !important;
        font-weight: ${btn_font_weight} !important;
        font-family: ${btn_font_family} !important;
        border-color: ${btn_border_color} !important;
        border-radius: ${btn_border_radius}px !important;
        border-width: 2px;
        border-style: solid;
      }
      .email-me-inlineButton {
        margin-top: ${btn_margin_top}px !important;
      }
      .email-me-button:hover {
        color: ${btn_hover_font_color} !important;            
        background-color: ${btn_hover_color} !important;        
      }
    `;btn_hover_animation&&(generalStyles+=`
      .email-me-inlineButton::after,
      .email-me-inlineButton::before,
      .email-me-submitButton::after,
      .email-me-submitButton::before {
          content:'';
          color: ${buttonData.btn_color};
          font-size: ${btn_font_size}px; 
          text-align: center; 
          border-radius: ${btn_border_radius}px;
          width: 0;
          height: 100%;
          background-color: ${btn_hover_color};
          position: absolute;
          left:0;
          transition: all ease-in-out .35s;
          top:0;
          z-index: -2;
      }
      .email-me-inlineButton::before,
      .email-me-submitButton::before {
          z-index: -1;
          background-color: ${btn_hover_color};
      }
      .email-me-inlineButton:hover,
        .email-me-submitButton:hover {
          z-index: 1;
          color: ${btn_hover_font_color} !important;
          background-color: ${btn_hover_color} !important;
      }
      .email-me-button:hover::before,
      .email-me-button:hover::after
      {
          width: 100%;
      }
      `);const styles=`
    <style>
    ${generalStyles}
    </style>
    `;document.head.insertAdjacentHTML("beforeend",styles)}function renderBtnAndPopup(){debug&&console.log("renderBtnAndPopup");const{toggler,ipt,mailingList}=renderSpecificPopup(),mountWindowElement=`       
      <div class="successSub">
        <div class="successSub_header">
            <img src="https://cdn.shopify.com/s/files/1/0576/6063/7389/t/1/assets/success.png?v=1629367773"/>
            <div class="successSub_header_text">${popupData.success_frame_title}</div>
            <div class="successSub_close-box">
                <div class="successSub_frame-close"></div>
            </div>
        </div>
        <div class="successSub_text">
            ${popupData.success_frame_content}
        </div>
      </div>
      <div id="email-me-frame">
        <div class="email-frame-content">
          <div class="close-box">
                <div class="frame-close"></div>
          </div>
          <div class="email-frame-header">
              <div class="frame-email-logo">
                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 5.324V15.5A1.5 1.5 0 001.5 17h17a1.5 1.5 0 001.5-1.5V5.324l-9.496 5.54a1 1 0 01-1.008 0L0 5.324z"
                            fill="#5C5F62"/>
                      <path d="M19.443 3.334A1.494 1.494 0 0018.5 3h-17c-.357 0-.686.125-.943.334L10 8.842l9.443-5.508z"
                            fill="#5C5F62"/>
                  </svg>
              </div>
              <div class="frame-title">${popupData.popup_header_text}</div>
          </div>
          <div class="split-line" style="border: 1px solid #d9d9d9;"></div>
          <div class="email-frame-body">
            <div class="frame-body-content">
              <span>${productTitle}</span>
            </div>
            <div>
            <select class="selected-unavailable-variant"></select>
            </div>
            ${toggler||""}
            <div>
              <input class="buyer-name" type="text" placeholder="${popupData.popup_name_placeholder_text}">
            </div>
            ${ipt}
            ${mailingList||""}
            <div class="frame-submit">
              <div class="email-me-button email-me-submitButton" style=" text-align:center; color: ${popupData.popup_btn_font_color}; background-color:  ${popupData.popup_btn_color}; border-radius: ${btnRadius}; font-size: ${btnFontSize}; ">
                ${popupData.popup_btn_value}
              </div>
            </div>
          </div>
          <div class="email-frame-footer">
            <div class="email-footer-tips">
              <span>${popupData.popup_footer_text}</span>
            </div>
          </div>
          <div class="email-provider" style="display: ${buttonData.is_branding_removed?"none":""};">
              Powered by <span><a class="email-app-link" target="_blank" href="https://apps.shopify.com/email-1?surface_detail=back+in+stock&surface_inter_position=1&surface_intra_position=10&surface_type=search">Sealapps</a></span>
          </div>
        </div>
      </div>`;document.body.insertAdjacentHTML("beforeend",mountWindowElement),renderButton().then(res=>{debug&&console.log("renderButton success"),res.code===200?(changeButtonPos(),createEmailButton(),listenVariantChange(),getBISEle(),popupData.popup_option!==1&&initSms()):debug&&console.log("Insert failed")})}function renderButton(){return new Promise(resolve=>{const{inline_status,float_status}=buttonData;let flag=0;if(inline_status){const{font_color,btn_color,btn_value,btn_margin_top}=buttonData,mountInlineBtn=` 
          <div id="product-restore-email" style="margin-top: ${btn_margin_top}px; max-width: ${inlineBtnWidth||"initial"}">
            <div class="email-me-button email-me-inlineButton" style="text-align:center; margin-top:0; color: ${font_color} ; background-color: ${btn_color} ; height:${inlineBtnHeight} ; border-radius: ${btnRadius||"2px"} ; font-size: ${btnFontSize||"14px"} ; font-weight: ${btnFontWeight||"inherit"};">
              ${btn_value}
            </div>
          </div>`;try{debug&&console.log("insert",insertEl,insertType),insertEl.insertAdjacentHTML(insertType,mountInlineBtn),flag++}catch{setInlineBtnWhenErr(mountInlineBtn),flag++}}if(float_status){const{offset,float_font_color,float_btn_color,float_btn_value}=buttonData,mountFloatBtn=` 
          <div id="product-restore-email-float" style="top:${offset+"px"}" class="${floatBtnPosition}">
              <div class="email-me-button email-me-floatButton" style="text-align:center; display:none; color: ${float_font_color} ; background-color:  ${float_btn_color} ; border-radius: ${btnRadius} ; font-size: ${btnFontSize}; font-weight: ${btnFontWeight}; ">
                  ${float_btn_value}
              </div>
          </div>`;document.body.insertAdjacentHTML("afterbegin",mountFloatBtn),flag++}flag>0?resolve({code:200,msg:"Success!"}):resolve({code:404,msg:"Insert failed"})})}function renderSpecificPopup(type){let ipt,toggler,mailingList;return type=popupData.popup_option||type,type===1?ipt=`
        <div>
          <input class="buyer-email" type="text" placeholder="${popupData.popup_placeholder_text}">
          <div class="invalid-email-tips">${popupData.popup_validation_text}</div>
        </div>
      `:type===2?ipt=`
        <div>
          <div class="buyer-phone-container">
            <input type="text" class="buyer-phone">
          </div>
          <div class="invalid-email-tips">${popupData.popup_validation_text}</div>
        </div>
      `:type===3&&(ipt=`
      <div>
        <input class="buyer-email" type="text" placeholder="${popupData.popup_placeholder_text}">
        <div class="buyer-phone-container">
          <input type="text" class="buyer-phone">
        </div>
        <div class="invalid-email-tips">${popupData.popup_validation_text}</div>
      </div>
      `,toggler=`
        <div class="notify-type-toggler">
          <div class="email-type">
              Email
          </div>
          <div class="sms-type">
              SMS
          </div>
        </div>
      `),renderSpecificStyle(type),inteStatus&&(mailingList=`
      <div class="join-mailing-container">
        <input id="join-mailing-list" type="checkbox" checked/>
        <label for="join-mailing-list" class="join-mailing-listLabel">
        ${popupData.popup_opt_in_text}
        </label>
      </div>
    `),{ipt,toggler,mailingList}}function renderSpecificStyle(type){switch(type){case 1:case 2:addStyle(`<style>
          #email-me-frame .email-frame-content {
            max-height: 412px !important;
          }
          </style>`);break;case 3:addStyle(`<style>
          #email-me-frame .email-frame-content {
            max-height: 459px !important;
          }
          </style>`);break;default:break}}function getBISEle(){switch(popupData.popup_option){case 1:emailInput=q(".buyer-email");break;case 2:smsInput=q(".buyer-phone");break;case 3:emailInput=q(".buyer-email"),smsInput=q(".buyer-phone");break}nameInput=q(".email-frame-body .buyer-name"),successFrame=q(".successSub"),invalidTip=q(".invalid-email-tips"),emailFrameElement=q("#email-me-frame"),closeBox=q("#email-me-frame .close-box"),submitBtn=q(".frame-submit .email-me-button"),variantSelector=q(".selected-unavailable-variant"),inlineEmailDiv=q("#product-restore-email"),floatEmailDiv=q("#product-restore-email-float"),inlineBtnElement=q(".email-me-inlineButton"),floatBtnElement=q(".email-me-floatButton"),mailingCheckbox=q("#join-mailing-list")||{},handleEleEvent()}function handleEleEvent(){switch(popupData.popup_option){case 1:emailInput.addEventListener("blur",verifyEmail);break;case 2:break;case 3:emailInput.addEventListener("blur",verifyEmail);break}submitBtn.addEventListener("click",subEmail),closeBox.addEventListener("click",function(){emailFrameElement.style.display="none",variantSelector.style.display!=="none"&&currentVariantOption&&currentVariantOption.removeAttribute("selected")}),successFrame.addEventListener("click",function(){successFrame.classList.remove("successSub_active")}),mountedUnVariantOptions(),initInlineAndFloatBtn()}function initInlineAndFloatBtn(){inlineBtnElement&&inlineBtnElement.addEventListener("click",function(){emailFrameElement.style.display="block";const selected_unavailable_variant=emailFrameElement.querySelector(".selected-unavailable-variant");for(let i=0;i<unVariantOptions.length;i++)addOptionsStatus===0&&selected_unavailable_variant.add(unVariantOptions[i]),unVariantOptions[i].getAttribute("value")===selectVariantId.toString()&&(currentVariantOption=selected_unavailable_variant.querySelectorAll("option")[i],currentVariantOption.setAttribute("selected","selected"));addOptionsStatus=1}),floatBtnElement&&floatBtnElement.addEventListener("click",function(){emailFrameElement.style.display="block";for(let i=0;i<unVariantOptions.length;i++)addOptionsStatus===0&&variantSelector.add(unVariantOptions[i]),unVariantOptions[i].getAttribute("value")===selectVariantId.toString()&&(currentVariantOption=variantSelector.querySelectorAll("option")[i],currentVariantOption.setAttribute("selected","selected"));addOptionsStatus=1})}function mountedUnVariantOptions(){let optionIndex=0;for(let i=0;i<variantData.length;i++)variantData[i].available||(variantData[i].title==="Default Title"&&(variantSelector.style.display="none"),unVariantOptions[optionIndex]=create({tag:"option",attributes:{value:variantData[i].id,textContent:variantData[i].title}}),optionIndex++)}function listenVariantChange(){const url=document.URL;listenUrlStatus(),url.indexOf("variant=")===-1&&checkVariantChange()}function checkVariantChange(){debug&&console.log("\u5B9A\u65F6\u5668\u5F00\u542F\uFF0C\u68C0\u67E5variant\u53D8\u5316");const curVariantId=window.ShopifyAnalytics?window.ShopifyAnalytics.meta.selectedVariantId:selectVariantId;handleVariantChange(curVariantId),listenVariantFlag&&setTimeout(checkVariantChange,100)}function listenUrlStatus(){overwritePushstate(),window.addEventListener("locationchange",()=>{if(document.URL!==initUrl){const currentUrl2=document.URL,vid=new URL(currentUrl2).searchParams.get("variant");debug&&console.log("vid",vid),initUrl=currentUrl2,vid&&handleVariantChange(vid),listenVariantFlag=!1,debug&&console.log("\u6E05\u9664\u5B9A\u65F6\u5668")}})}function handleVariantChange(vid){vid&&String(selectVariantId)!==String(vid)&&(selectVariantId=vid,currentVariant=variantData.find(o=>o.id==vid),available=currentVariant.available,(!available&&!btnStyleSwitch||!popupStyleSwitch)&&getAllStyle(),!available&&!selBtnStatus&&createEmailButton(),selBtnStatus===1&&(debug&&console.log("initEmailToMeEle"),debug&&console.log(currentVariant),initEmailToMeElement()))}function createEmailButton(){if(debug&&console.log("createEmailButton"),selBtnStatus===0){const url=baseUrl+"api/v1/email/selBtnStatus";request(url,{shopId}).then(res=>{const{code,data}=res;code===200&&(data.status==1||data.status==2||data.status==0||data.snsStatus?(selBtnStatus=1,initEmailToMeElement()):selBtnStatus=data.status)})}}function initEmailToMeElement(){if(generalData.btn_display_all){inlineBtnElement&&(inlineBtnElement.style.display="flex",inlineEmailDiv.style.display="flex"),floatBtnElement&&(floatBtnElement.style.display="flex",floatEmailDiv.style.display="flex");return}selBtnStatus===1&&!available?(inlineBtnElement&&(inlineBtnElement.style.display="flex",inlineEmailDiv.style.display="flex"),floatBtnElement&&(floatBtnElement.style.display="flex",floatEmailDiv.style.display="flex")):(inlineBtnElement&&(inlineEmailDiv.style.display="none"),floatBtnElement&&(floatEmailDiv.style.display="none"))}function verifyEmail(){const email=emailInput.value;new RegExp(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/).test(email)?invalidTip.style.visibility="hidden":toggleInvalidTip(!0,{type:"email",info:popupData.popup_validation_text})}function create({tag,appendTo,children=[],attributes={},events={}}){const element=document.createElement(tag);return Object.entries(attributes).forEach(([key,value])=>{element[key]=value}),Object.entries(events).forEach(([key,value])=>{element.addEventListener(key,value)}),appendTo&&appendTo.appendChild(element),children.forEach(child=>element.appendChild(child)),element}function subEmail(){const{popup_validation_text}=popupData;let buyerName;switch(nameInput&&(buyerName=nameInput.value),selectedType.type){case"sms":smsInput&&smsInput.value||""?iti.isValidNumber()?(toggleInvalidTip(!1),subscribeSms({buyerName})):toggleInvalidTip(!0,{type:"sms",info:popup_validation_text}):toggleInvalidTip(!0,{type:"sms",info:popup_validation_text});break;case"email":const email=emailInput.value;email?new RegExp(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/).test(email)?(toggleInvalidTip(!1),subscribeEmail({buyerName})):toggleInvalidTip(!0,{type:"email",info:popup_validation_text}):toggleInvalidTip(!0,{type:"email",info:popup_validation_text});break;default:return}}function toggleInvalidTip(show,data){const style=getComputedStyle(invalidTip),{type,info}=data||{type:selectedType.type,info:popupData.popup_validation_text};switch(type){case"sms":style.visibility==="hidden"?(invalidTip.style.visibility="visible",invalidTip.innerHTML=info):invalidTip.style.visibility="hidden";break;case"email":style.visibility==="hidden"?(invalidTip.style.visibility="visible",invalidTip.innerHTML=info):invalidTip.style.visibility="hidden";break;default:invalidTip.style.visibility="hidden";break}debug&&console.log(invalidTip),show?invalidTip.style.visibility="visible":show===!1&&(invalidTip.style.visibility="hidden")}function subscribeSms(data){const params={shopId,variant_rid:variantSelector.value,receiver_number:formatPhoneNumber(smsInput.value.trim()),region:iti.getSelectedCountryData().iso2.toUpperCase(),is_integration:Number(mailingCheckbox.checked||!1),receiver_name:data.buyerName||"customer",customer_rid:0},url=baseUrl+"api/v1/sns/insCustomerSnsInfo";submitBtn.parentElement.className="frame-submit loading",request(url,params).then(res=>{const{code}=res;code===200?(emailFrameElement.style.display="none",successFrame.classList.add("successSub_active"),setTimeout(function(){successFrame.classList.remove("successSub_active")},4e3)):code===108||code===107?(invalidTip.style.visibility="visible",invalidTip.innerHTML=popupData.popup_subscribed_text):code===109&&(invalidTip.style.visibility="visible",invalidTip.innerHTML=popupData.popup_validation_text)}).finally(()=>{submitBtn.parentElement.className="frame-submit"})}function subscribeEmail(data){const params={shopId,variant_rid:variantSelector.value,receiver_email:document.getElementsByClassName("buyer-email")[0].value,receiver_name:data.buyerName||"customer",is_integration:Number(mailingCheckbox.checked||!1),customer_rid:0},url=baseUrl+"api/v1/email/insCustomerEmailInfo";submitBtn.parentElement.className="frame-submit loading",request(url,params).then(res=>{const{code}=res;code===200?(emailFrameElement.style.display="none",successFrame.classList.add("successSub_active"),setTimeout(function(){successFrame.classList.remove("successSub_active")},4e3)):code===108||code===107?(invalidTip.style.visibility="visible",invalidTip.innerHTML="* You are already subscribed to this product."):code===109&&(invalidTip.style.visibility="visible",invalidTip.innerHTML=popupData.popup_validation_text)}).finally(()=>{submitBtn.parentElement.className="frame-submit"})}function formatPhoneNumber(num){const code=iti.getSelectedCountryData().dialCode;return num.startsWith(code)?num:code+num}function initSms(){const emailInput2=q(".buyer-email"),phoneInput=q(".buyer-phone"),phoneContainer=q(".buyer-phone-container"),emailTypeBtn=q(".email-type"),smsTypeBtn=q(".sms-type");initPhoneInput().then(res=>{res.code===200&&popupData.popup_option===3&&(selectedType=new Proxy({type:"email"},{set(target,key,newVal){return debug&&console.log(target,key,newVal),target[key]=newVal,toggleInput(newVal),!0}}),toggleInput(selectedType.type),emailTypeBtn.addEventListener("click",()=>{selectedType.type="email"}),smsTypeBtn.addEventListener("click",()=>{selectedType.type="sms"}))});function initPhoneInput(){return new Promise(resolve=>{addScript("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css").then(cssRes=>{cssRes.code===200&&(document.head.insertAdjacentHTML("beforeend",`
              <style>
              .iti__flag {background-image: url("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/img/flags.png");}
              @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
              .iti__flag {background-image: url("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/img/flags@2x.png");}
              }
              .iti.iti--allow-dropdown {
                  width: 100%;
                  display: flex;
                  height: var(--sa-button-height-normal);
                  margin-top: 10px;
              }
              .iti__country {
                color: #777777;
              }
              </style>
            `),addScript("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/intlTelInput.min.js",!0).then(script=>{script.onload=function(){iti=window.intlTelInput(phoneInput,{utilsScript:"https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js",autoPlaceholder:"aggressive"}),debug&&console.log("Script Loaded"),debug&&console.log(phoneInput),phoneInput.addEventListener("input",e=>{debug&&console.log("getNumber",iti.getNumber()),debug&&console.log("getSelectedCountryData",iti.getSelectedCountryData()),iti.isValidNumber()?toggleInvalidTip(!1):toggleInvalidTip(!0)}),phoneInput.addEventListener("blur",e=>{debug&&console.log("wuhu"),debug&&console.log("isValidNumber",iti.isValidNumber()),iti.isValidNumber()?toggleInvalidTip(!1):toggleInvalidTip(!0)})},document.body.appendChild(script),resolve({code:200})}))})})}function toggleInput(type){switch(invalidTip.style.visibility="hidden",type){case"sms":emailInput2.style.display="none",phoneContainer.style.display="flex",emailTypeBtn.className="email-type",smsTypeBtn.className="sms-type type-selected";break;case"email":smsTypeBtn.className="sms-type",emailInput2.style.display="block",phoneContainer.style.display="none",emailTypeBtn.className="email-type type-selected";break;default:invalidTip.style.visibility="hidden";break}}}function addScript(url,returnWithScript=!1){return new Promise((resolve,reject)=>{try{const type=url.endsWith(".js")&&"js"||"css";if(type==="js"){const script=document.createElement("script");script.setAttribute("type","text/javascript"),script.setAttribute("src",url),returnWithScript&&resolve(script),document.head.appendChild(script),resolve({code:200,data:script,type:"script"})}else if(type==="css"){const link=document.createElement("link");link.setAttribute("rel","stylesheet"),link.setAttribute("href",url),returnWithScript&&resolve(link),document.head.appendChild(link),resolve({code:200,data:link,type:"style"})}}catch(err){reject({code:600,err})}})}function request(url,params,callback,method="POST"){return new Promise((resolve,reject)=>{url||resolve({code:999,data:"\u6CA1\u6709\u4F20api\u5730\u5740"});try{const finalParams=params||{};(params&&!Object.keys(params).includes("shopId")||!params)&&(finalParams.shopId=shopId);const xmlHttp=new XMLHttpRequest;xmlHttp.open(method,url,!0),xmlHttp.setRequestHeader("Content-Type","application/json"),xmlHttp.send(JSON.stringify(finalParams)),xmlHttp.onreadystatechange=function(){if(xmlHttp.readyState==4&&xmlHttp.status==200||xmlHttp.status==304){const json=JSON.parse(this.responseText),{code,data}=json;code===200?(callback&&callback(data),resolve(json)):code!==500&&resolve(json)}}}catch(err){reject(err)}})}function importStyles(){document.head.insertAdjacentHTML("beforeend",`<style>
    body {
      --sa-border-normal: 1px solid #d9d9d9;
      --sa-border-hover: 2px solid skyblue;
      --sa-button-height-normal: 44px;
      --sa-border-radius-input: 4px;
      --sa-border-radius-button: 4px;
      --sa-border-color: #d9d9d9;
      --sa-disabled-bgc: #f2f2f2;
      --sa-btn-hover-bgc: #f6f6f7;
      --sa-input-padding: 8px;
    }
    #email-me-frame * {
        box-sizing: border-box;
    }
    #email-me-frame *:empty {
      display: inherit;
    }
  .email-me-button{
    width: 100%;
    height: var(--sa-button-height-normal);
    /*background-color: rgb(51, 51, 51);*/
    /*border-radius: 7px;*/
    /*color: white;*/
    border-width: 0px;
    font-size: 15px;
    cursor: pointer;
    letter-spacing: 1px;
    border-radius: var(--sa-border-radius-button);
    align-items:center;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    transition: all linear .15s;
    position: relative;
  }
  .email-me-inlineButton {
    display: none;
  }
  #email-me-frame {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.2);
    z-index: 9999999;
    display: none;
  }

  #email-me-frame input {
    background-color: #ffffff;
    border: 1px solid var(--sa-border-color);
    border-radius: var(--sa-border-radius-input);
  }
  
  #email-me-frame .email-frame-content{
    width: 65%;
    /*height: 358px;*/
    max-width: 398px;
    min-width: 300px;
    background: white;
    border-radius: 7px;
    padding-bottom:16px;
    border: 1px solid var(--sa-border-color);
    box-shadow: 0 0 18px #00000030;
    animation: fadeIn .15s linear;
    position: fixed;
    top: 50%; left: 50%;
    bottom: 0;
    height: 100%;
    max-height: 508px;
    transform: translate(-50%, -50%);
    overflow-y: scroll;
  }
  .email-frame-content::-webkit-scrollbar {
    /*\u6EDA\u52A8\u6761\u6574\u4F53\u6837\u5F0F*/
    width: 4px; /*\u9AD8\u5BBD\u5206\u522B\u5BF9\u5E94\u6A2A\u7AD6\u6EDA\u52A8\u6761\u7684\u5C3A\u5BF8*/
    height: 1px;
  }
  .email-frame-content::-webkit-scrollbar-thumb {
    /*\u6EDA\u52A8\u6761\u91CC\u9762\u5C0F\u65B9\u5757*/
    border-radius: 10px;
    background: #a9a9a9;
  }
  .email-frame-content::-webkit-scrollbar-track {
    /*\u6EDA\u52A8\u6761\u91CC\u9762\u8F68\u9053*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
  
  #email-me-frame .frame-close {
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 5px;
      cursor: pointer;
      display: inline-block;
      width: 100%;
      height: 2px;
      background: #333;
      transform: rotate(
              45deg
      );
  }
  #email-me-frame .frame-close::after{
      content: "";
      display: block;
      height: 2px;
      background: #333;
      transform: rotate(
              -90deg
      );
  }
  
  #email-me-frame .email-frame-header{
      display: flex;
      justify-content: center;
      clear: both;
      padding-top: 2px;
      padding-left: 30px;
      margin-bottom: 7px;
      font-family: "Arial",sans-serif;
  
  }
  
  #email-me-frame .close-box{
      width: 20px;
      height: 19px;
      float: right;
      margin-right: 5px;
      margin-top: 5px;
      cursor: pointer;
  }
  
  #email-me-frame .frame-email-logo svg{
      background-size: 25px 25px;
      width: 24px;
      margin-top: 3px;
  }
  
  #email-me-frame .frame-title{
      padding-left: 13px;
      flex: 1;
      color:#1A1B18;
      font-size: 16px;
      font-weight: 600;
      padding-top: 3px;
  }
  
  #email-me-frame .split-line {
      border: 1px solid var(--sa-border-color);
  }
  
  #email-me-frame .email-frame-body{
      padding-left: 30px;
      padding-right: 30px;
  }
  
  #email-me-frame .frame-body-content{
      letter-spacing: 0.01rem;
      line-height: 1.6rem;
      font-weight: 500;
      font-size: 15px;
      margin-top:16px;
      margin-bottom: 5px;
      color:#1A1B18;
  }
  
  #email-me-frame .buyer-email,
  #email-me-frame .buyer-phone-input,
  #email-me-frame .buyer-name{
      border-radius: var(--sa-border-radius-input);
      border: 1px solid var(--sa-border-color);
      margin: 10px 0 0 0;
      width: 100%;
      font-size: 15px ;
      outline: none !important;
      height: var(--sa-button-height-normal) !important;
      color: #000 !important;
      background: #fff !important;
      padding: var(--sa-input-padding) !important;
  }
  .buyer-phone-input {
      border-left: none;
  }

  #email-me-frame .notify-type-toggler {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      font-size: 15px ;
      height: var(--sa-button-height-normal) !important;
      color: #000 !important;
      background: #fff !important;
      margin-top: 10px;
  }
  .notify-type-toggler > div {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid var(--sa-border-color);
      height: 100%;
      cursor: pointer;
      transition: all linear .14s;
  }
  .notify-type-toggler > div:hover {
      background: var(--sa-btn-hover-bgc)
  }
  .notify-type-toggler > div:nth-child(1) {
      border-radius: var(--sa-border-radius-button) 0 0 5px;
  }
  .notify-type-toggler > div:nth-child(2) {
      border-left: 0;
      border-radius: 0 5px 5px 0;
  }
  .join-mailing-container {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 12px;
    margin-top: 4px;
  }
  .join-mailing-listLabel {
    margin: 0 0 0 8px;
    color: #333333 !important;
  }
  #email-me-frame .buyer-phone-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      height: var(--sa-button-height-normal);
      padding: var(--sa-input-padding);
  }
  #email-me-frame .country-selector {
      width: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      border: 1px solid var(--sa-border-color);
      cursor: pointer;
  }
  #email-me-frame .country-selector:hover {
      background: var(--sa-disabled-bgc);
  }
  #email-me-frame .country-selector-list {
      max-width: 120px;
      position: absolute;
      border: 1px solid var(--sa-border-color);
      border-radius: 8px;
      background-color: #fff;
      list-style: none;
      padding: 0px;
      max-height: 120px;
      overflow-y: scroll;
      margin-bottom: 50%;
  }
  #email-me-frame .country-selector-list li {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      padding: var(--sa-input-padding);
      cursor: pointer;
      transition: all linear .14s;
      bottom: 0;
  }
  #email-me-frame .country-selector-list li:hover {
      background-color: #eeeeee;
  }
  .buyer-phone {
      outline: none;
      flex: 1;
      transition: all linear .14s;
      border: var(--sa-border-normal);
      border-radius: var(--sa-border-radius-button);
  }
  input::-webkit-input-placeholder{
      color:gray;
      font-size:15px;
  }
  
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color:gray;
      font-size:15px;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color:gray;
      font-size:15px;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
      color:gray;
      font-size:15px;
  }
  
  
  #email-me-frame .frame-submit{
      position: relative;
  }

  /* loading\u7684\u4EE3\u7801 */
  .frame-submit.loading {
    pointer-events: none;
    cursor: not-allowed;
  }
  .frame-submit.loading::after {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border-bottom: 2px solid #ddd;
    border-right: 2px solid #ddd;
    animation: spin ease-in-out 0.8s infinite;
    position: absolute;
    top: 11px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .frame-submit.loading .email-me-submitButton {
    opacity: 0;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  #email-me-frame .selected-unavailable-variant{
      border-radius: var(--sa-border-radius-button);
      border: 1px solid var(--sa-border-color);
      margin: 10px 0 0 0;
      width: 100%;
      height: var(--sa-button-height-normal);
      font-size: 15px;
      outline: none;
      color: #000;
      padding: var(--sa-input-padding) !important;
      background: #fff;
  }
  
  #email-me-frame .invalid-email-tips{
      color: rgb(219, 17, 42);
      font-weight: 500;
      letter-spacing: 0;
      visibility: hidden;
      line-height: 24px;
      font-size: 12px;
  }
  
  #email-me-frame .email-frame-footer{
      padding: 0 30px;
      margin-top: 20px;
  }
  
  #email-me-frame .email-frame-footer .email-footer-tips{
      font-size: 14px;
      font-family: "Arial",sans-serif;
      line-height: 1.1em;
      color: #ccc;
  }
  #email-me-frame .email-app-link{
      color: #008ddd;
  }
  #email-me-frame .email-app-link:hover{
      color: #0089d6;
  }
  #email-me-frame .email-app-link:visited{
      color: #008ddd;
  }
  #email-me-frame .email-app-link:active{
      color: #008ddd;
  }
  #email-me-frame .email-provider {
      margin-top: 8px;
      text-align: center !important;
      font-family: "Arial",sans-serif;
      color: black;
      font-size: 12px;
  }
  .successSub_header img {
    width: 32px;
    margin: 0;
}
  .successSub {
    transition: width 0.5s ease-out, opacity 0.5s ease-in, visibility 0.5s ease-in;
    max-width: 350px;
    background: rgb(255, 255, 255);
    padding: 20px;
    border-radius: 7px;
    border:1px solid #445958 ;
    display: block;
    z-index: -1;
    position: fixed;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    opacity: 0;
    color: #464646;
}
.successSub_active {
    width: 100%;
    visibility: visible;
    opacity: 1;
    z-index: 999999999;
}
#product-restore-email img {
    width: 44px;
    margin: 0;
}
#email-me-frame img {
    /* width: 100%; */
    width: 50px;
    margin-right: 8px;
}
.successSub_header {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: flex;
}
.successSub_header_text {
    font-weight: 700;
    flex: 1;
    padding-left: 8px;
}
.successSub_close-box {
    width: 20px;
    height: 20px;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transform: translate(8px, -16px);
}
.successSub_frame-close {
    margin-bottom: 10px;
    cursor: pointer;
    display: inline-block !important;
    width: 100%;
    height: 1px;
    background: #333;
    transform: rotate( 
        45deg
    );
}
.successSub_frame-close::after {
    content: '';
    display: block;
    height: 1px;
    background: #333;
    transform: rotate( 
        -90deg
    );
}
.successSub_text {
    margin-top: 8px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
}
  #product-restore-email{
      justify-content: flex-start;
      width: 100%;
      flex:1;
  }
  #product-restore-email input {
    background: #ffffff;
  }
  #product-restore-email-float{
      display: flex;
      z-index:99999999999;
      justify-content: center;
      position:fixed;

  }
  .float-btn-left{
      transform: rotate(90deg) translateY(-100%);
      transform-origin: 0% 0%;
      left:0;
  }
  .float-btn-right{
      transform: rotate(-90deg) translateY(-100%);
      transform-origin: 100% 0%;
      right:0;
  }
  #product-restore-email-float .email-me-button{
      padding: 0.8rem 1.2rem;
  }
  #email-me-frame .email-provider span{
      color: blue;
  }
  @keyframes fadeIn {
      0% {
          opacity: .6;
      }
      100% {
          opacity: 1;
      }
  }
  /* \u6EDA\u52A8\u6761\u8BBE\u7F6E\u6CA1\u6709\u751F\u6548 */
  /* \u6EDA\u52A8\u6761\u6574\u4F53\u90E8\u5206\uFF0C\u53EF\u4EE5\u8BBE\u7F6E\u5BBD\u5EA6\u5565\u7684 */
  #email-me-frame .country-selector-list ::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }
  /* \u6EDA\u52A8\u6761\u4E24\u7AEF\u7684\u6309\u94AE */
  #email-me-frame .country-selector-list ::-webkit-scrollbar-button {
    display: none !important;
  }
  /* \u5916\u5C42\u8F68\u9053 */
  #email-me-frame .country-selector-list ::-webkit-scrollbar-track  {
    display: none !important;
  }
  /* \u5185\u5C42\u6EDA\u52A8\u69FD */
  #email-me-frame .country-selector-list ::-webkit-scrollbar-track-piece{
    display: none !important;
  }
  /* \u6EDA\u52A8\u7684\u6ED1\u5757  */
  #email-me-frame .country-selector-list ::-webkit-scrollbar-thumb {
    background-color:#ff9900;
    background-color:rgba(255,153,0, 0.6);
    border-radius: 10px;
  }
  .type-selected {
    pointer-events: none;
    background-color: var(--sa-disabled-bgc);
  }
  
              </style>`)}function addStyle(style){typeof style=="string"?document.head.insertAdjacentHTML("beforeend",style):document.head.appendChild(style)}function getQueryString(name){const reg=new RegExp("(^|&)"+name+"=([^&]*)(&|$)","i"),r=window.location.search.substr(1).match(reg);return r!=null?unescape(r[2]):null}function changeStatus(data){const emailCustomerId=getQueryString("emailCustomerId");if(!emailCustomerId)return;const variantId=getQueryString("variant");if(!variantId)return;const{baseUrl:baseUrl2,shopId:shopId2}=data,params={id:emailCustomerId,shopId:shopId2,variantId},url=baseUrl2+"api/v1/email/changeEmailStatus";request(url,params)}function overwritePushstate(){const oldPushState=history.pushState;history.pushState=function(){const ret=oldPushState.apply(this,arguments);return window.dispatchEvent(new Event("pushstate")),window.dispatchEvent(new Event("locationchange")),ret};const oldReplaceState=history.replaceState;history.replaceState=function(){const ret=oldReplaceState.apply(this,arguments);return window.dispatchEvent(new Event("replacestate")),window.dispatchEvent(new Event("locationchange")),ret},window.addEventListener("popstate",()=>{window.dispatchEvent(new Event("locationchange"))})}function q(c){return document.querySelector(c)}function qa(c){return document.querySelectorAll(c)}})();
//# sourceMappingURL=/s/files/1/0548/9472/3227/t/13/assets/product_restore_email.js.map?v=1738240468
